import { dsl } from '@wix/yoshi-serverless/wrap';

export const queryInstalledApps = dsl({
          functionName: 'queryInstalledApps',
          fileName: 'api/installed-apps.api',
        });